import { useEffect } from "react";
import { SITE_URL, siteConfig } from "@/mocks/site";
import { setCanonical, setMetaTag } from "@/lib/seo";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  type?: string;
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export default function Seo({ title, description, keywords, path, type = "website", image, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    setMetaTag("name", "description", description);
    if (keywords) setMetaTag("name", "keywords", keywords);
    setCanonical(`${SITE_URL}${path}`);
    setMetaTag("property", "og:title", title);
    setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:type", type);
    setMetaTag("property", "og:url", `${SITE_URL}${path}`);
    setMetaTag("property", "og:site_name", siteConfig.name);
    setMetaTag("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMetaTag("name", "twitter:title", title);
    setMetaTag("name", "twitter:description", description);
    if (image) {
      setMetaTag("property", "og:image", image);
      setMetaTag("name", "twitter:image", image);
    }
  }, [title, description, keywords, path, type, image]);

  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      {blocks.map((block, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(block) }}
        />
      ))}
    </>
  );
}